module.exports = __webpack_public_path__ + "img/ylands_comp_create_top.91fa4bb3.png";